module.exports = __webpack_public_path__ + "static/media/defWithTimes.978e4d2f.docx";